(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-description-accordions"] && !Shopify.designMode) return;
  try {
    (() => {
    const rootSelector = '[data-product-description-accordions]';
    const enhancedFlag = 'productDescriptionAccordionsEnhanced';

    const cleanText = (value) => value.replace(/\s+/g, ' ').trim();
    const normalizeText = (value) => cleanText(value)
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase();

    const isKnownSectionTitle = (value) => {
      const title = normalizeText(value);

      return title === 'styling tipy'
        || title === 'styling typy'
        || title === 'stylingove tipy'
        || title === 'stylingove typy'
        || title === 'starostlivost'
        || title === 'technicke parametre'
        || title.startsWith('farebna typologia');
    };

    const findTitleAndContent = (item) => {
      const title = item.querySelector('strong');

      if (!title) {
        return null;
      }

      let content = title.nextElementSibling;

      if (!content || content.tagName !== 'DIV') {
        content = Array.from(item.querySelectorAll('div')).find((candidate) => {
          return candidate !== title.parentElement && cleanText(candidate.textContent) !== cleanText(title.textContent);
        });
      }

      if (!content || cleanText(title.textContent) === '') {
        return null;
      }

      if (cleanText(content.textContent) === '' && !isKnownSectionTitle(title.textContent)) {
        return null;
      }

      return { title, content };
    };

    const createAccordion = ({ title, content }) => {
      const disclosure = document.createElement('accordion-disclosure');
      disclosure.className = 'accordion';

      const details = document.createElement('details');
      details.className = 'accordion__disclosure group';
      details.setAttribute('aria-expanded', 'false');

      const summary = document.createElement('summary');
      summary.innerHTML = `
        <span class="accordion__toggle h6">
          <span>${title.innerHTML.trim()}</span>
          <span class="animated-plus group-expanded:rotate" aria-hidden="true"></span>
        </span>
      `;

      const accordionContent = document.createElement('div');
      accordionContent.className = 'accordion__content prose';
      accordionContent.innerHTML = content.innerHTML.trim();

      details.append(summary, accordionContent);
      disclosure.append(details);

      return disclosure;
    };

    const mergeManufacturerAccordion = (root) => {
      const manufacturerGroup = root.querySelector('[data-product-manufacturer-accordion-group]');

      if (!manufacturerGroup) {
        return;
      }

      const contentGroups = Array.from(root.children).filter((child) => {
        return child !== manufacturerGroup && child.classList.contains('product-description-accordions__group');
      });
      const lastContentGroup = contentGroups[contentGroups.length - 1];

      if (!lastContentGroup) {
        return;
      }

      Array.from(manufacturerGroup.children).forEach((child) => lastContentGroup.append(child));
      manufacturerGroup.remove();
    };

    const placeGramaz = (root) => {
      const gramaz = root.querySelector('[data-product-description-gramaz]');

      if (!gramaz) {
        return;
      }

      const firstAccordionGroup = root.querySelector('.product-description-accordions__group');
      const boundary = firstAccordionGroup || gramaz;
      let dimensionsItem = null;

      for (const child of root.children) {
        if (child === boundary) {
          break;
        }

        const listItems = child.matches('li') ? [child] : Array.from(child.querySelectorAll('li'));
        dimensionsItem = listItems.find((item) => {
          const text = normalizeText(item.textContent);

          return text.startsWith('rozmery:') || text.startsWith('rozmer:');
        });

        if (dimensionsItem) {
          break;
        }
      }

      if (dimensionsItem) {
        const gramazItem = document.createElement('li');
        gramazItem.setAttribute('data-product-description-gramaz', '');
        gramazItem.innerHTML = gramaz.innerHTML;
        dimensionsItem.after(gramazItem);
        gramaz.remove();
        return;
      }

      if (firstAccordionGroup) {
        firstAccordionGroup.before(gramaz);
      }
    };

    const enhanceRoot = (root) => {
      if (root.dataset[enhancedFlag] === 'true') {
        return;
      }

      root.dataset[enhancedFlag] = 'true';

      Array.from(root.children).forEach((candidate) => {
        if (
          candidate.tagName !== 'DIV'
          || candidate.classList.contains('keyana-product-videos')
          || candidate.classList.contains('product-description-accordions__group')
        ) {
          return;
        }

        const items = Array.from(candidate.children).map(findTitleAndContent).filter(Boolean);

        if (items.length === 0) {
          return;
        }

        const group = document.createElement('div');
        group.className = 'product-description-accordions__group accordion-group';

        items.forEach((item) => {
          group.append(createAccordion(item));
        });

        candidate.replaceWith(group);
      });

      mergeManufacturerAccordion(root);
      placeGramaz(root);
    };

    const enhanceAll = (scope = document) => {
      scope.querySelectorAll(rootSelector).forEach(enhanceRoot);
    };

    enhanceAll();
    document.addEventListener('shopify:section:load', (event) => enhanceAll(event.target));

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType !== Node.ELEMENT_NODE) {
            return;
          }

          if (node.matches(rootSelector)) {
            enhanceRoot(node);
          } else {
            enhanceAll(node);
          }
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
